import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cny',
  templateUrl: './cny.component.html',
  styleUrls: ['./cny.component.scss']
})
export class CnyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
